import { Flex, Grid, Heading, Link, Text } from "@adobe/react-spectrum";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { selectAccessToken } from "store/slices/credentials";

export const Main: FC = () => {
  const accessToken = useSelector(selectAccessToken);
  const navigate = useNavigate();

  useEffect(() => {
    if (accessToken) {
      navigate("/quizzer");
    }
  }, [accessToken]);

  return (
    <Grid
      areas={["step0 welcome welcome welcome step4"]}
      columns={["1fr 1fr 1fr 1fr 1fr"]}
      gap="size-600"
      marginTop="size-800"
    >
      <Flex direction="column" gridArea="welcome">
        <Heading level={1}>Welcome to BOB Quizzer!</Heading>
        <Text>
          Get ready to challenge your child or class with randomized quiz
          questions straight from the official BOB quizzing spreadsheet! Our
          interactive format mirrors the real BOB competition, helping students
          prepare in a fun and engaging way.
          <br />
          <br />
          To get started, simply log in with your Google account and grant the
          necessary Drive permissions. Don't worry—your account is only used to
          access the document and generate quiz questions. Want to know more?
          Check out our Privacy Policy for details.
          <br />
          <br />
          Let's start quizzing! 🚀
        </Text>

        <Link href="/privacy" target="_blank">
          Privacy Policy
        </Link>
      </Flex>
    </Grid>
  );
};
